import { useAuth0 } from '@auth0/auth0-react'

import React from 'react'

// import { Link } from 'react-router-dom'
import UserService from '../services/UserService/UserService'

export const ProfileIncompleteBar: React.FC = () => {
  const { user, isAuthenticated } = useAuth0()

  if (!isAuthenticated || !user) return null

  const userDetails = UserService.formatUser(user)

  if (userDetails.work_experience && userDetails.work_settings) return null

  return (
    <div className="flex items-start gap-3 px-4 py-3 rounded-xl border border-yellow-300 bg-yellow-50">
      <svg
        className="w-5 h-5 mt-0.5 flex-shrink-0 text-yellow-500"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
        />
      </svg>
      <div>
        <p className="text-sm font-semibold text-yellow-800">Complete your profile</p>
        <p className="text-xs text-yellow-700 mt-0.5">
          Add your years of experience and work setting to make your reviews more credible.{' '}
          {/* <Link to="/profile" className="underline font-semibold hover:text-yellow-900">
            Go to Profile
          </Link> */}
        </p>
      </div>
    </div>
  )
}
